/**
 * Shared upload constraints used by both client and Convex handlers.
 */
export const MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024; // 100 MB

export const AUDIO_CONTENT_TYPES = [
  'audio/mpeg',
  'audio/mp3',
  'audio/wav',
  'audio/x-wav',
  'audio/wave',
  'audio/mp4',
  'audio/m4a',
  'audio/x-m4a',
  'audio/aac',
  'audio/ogg',
  'audio/flac',
  'audio/x-flac',
  'audio/x-ms-wma',
  'audio/aiff',
  'audio/x-aiff',
  'audio/opus',
  'audio/webm',
  'audio/x-ds2',
  'audio/x-dss',
  'application/octet-stream', // Dictation devices can send generic MIME
] as const;

export const AUDIO_EXTENSIONS = [
  '.mp3',
  '.wav',
  '.m4a',
  '.aac',
  '.ogg',
  '.flac',
  '.wma',
  '.aiff',
  '.aif',
  '.opus',
  '.webm',
  '.ds2',
  '.dss',
] as const;
